<kendo-grid [kendoGridBinding]="GridData" [rowReorderable]="true" [pageable]="false"  (cellClick)="cellClickHandler($event)" [id]="GridId">
    <kendo-grid-rowreorder-column [width]="40"></kendo-grid-rowreorder-column>
    <ng-container *ngFor="let res of Columns" [ngSwitch]="res.controlType">

        <kendo-grid-column [filterable]="res.IsFilterable" [sortable]="res.IsFilterable" [hidden]="!res.IsVisible"
            *ngSwitchCase="'text'" [field]="res.Name" [title]="res.DisplayName | translate"
            [width]="res.Width ? res.Width: 140">
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ dataItem['Text'] | translate}}
            </ng-template>
        </kendo-grid-column>

        <kendo-grid-column [filterable]="res.IsFilterable" [sortable]="res.IsFilterable" [hidden]="!res.IsVisible"
            *ngSwitchCase="'boolean'" [filter]="res.DataType" [width]="res.Width ? res.Width: 140" [field]="res.Name"
            [title]="res.DisplayName | translate">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex" let-columnIndex="columnIndex">
                <input type="checkbox" (change)="changeCheckBox(GridData[rowIndex],res.Name)"
                [(ngModel)]="GridData[rowIndex][res.Name]" [disabled]="_DisableAll==true?true:!GridData[rowIndex]['Editable'][res.Name]" />
            </ng-template>
        </kendo-grid-column>
    </ng-container>
</kendo-grid>